module.exports = __webpack_public_path__ + "monitor_control_icon.99beff4f85cb5b072a1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/monitor_control_icon.svg
// module id = 1408
// module chunks = 3